/* eslint no-console: ["error", { allow: ["warn", "error", "log", "info"] }] */
let RecordRTC = require('recordrtc')
let Vimeo = require('vimeo').Vimeo;

var CLIENT_ID = "e497d8839f1f561852c70ca7b51f5d839e2881ca"
var CLIENT_SECRET = "ba2YlmG+LF+AhMleWvRrvKcdZaFUSCsUEaatyX+oihMJG8BzHgxCU12VaJJ5Rv5K3n+rRHx2mjuiniG3WnqBuH+fQDIXfRMqhrkHx/k5wt2yjJVec5YhQDmVfA7y1hc2"
var ACCESS_TOKEN = "76e93d83d363519cf021fd32f8fda8d8"
var client = new Vimeo(CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN);

let uploadProgress;

export default {

    async startRecording() {

        this.captureScreen(screen => {
            this.captureAudio(audio => {
                this.audio = audio
                this.screen = screen

                this.screen.width = window.screen.width
                this.screen.height = window.screen.height
                this.screen.fullcanvas = true
                this.screen.muted = true
                this.screen.volume = 0

                this.streams = new MediaStream()
                this.screen.getTracks().forEach(track => {
                    this.streams.addTrack(track)
                })

                this.audio.getTracks().forEach(track => {
                    this.streams.addTrack(track)
                })

                this.recorder = RecordRTC(this.streams, {
                    type: 'video',
                    // mimeType: 'video/webm;codecs=h264',
                    mimeType: 'video/webm',
                    disableLogs: false,
                    audioBitsPerSecond: 64000
                    // videoBitsPerSecond: 128000,
                    // frameInterval: 60
                })

                this.recorder.startRecording()
            })
        })
    },






    async stopRecording(funUpload) {
        //console.log(typeof funUpload)
        uploadProgress = funUpload

        this.isRecordingStarted = false
        this.recorder.stopRecording(() => {
            let a = [this.screen, this.audio]
            a.forEach(stream => {
                stream.getTracks().forEach(track => {
                    track.stop()
                })
            })
        })

        
       // console.info('Gravação encerrada');
    },

    async uploadToVimeo(){
       // console.log(typeof uploadProgress)

        await client.upload(
            this.recorder.getBlob(),

            function (uri) {
                //console.log('Upload Completo. URL:', uri)
                localStorage.setItem('videourl',uri)
            },
            function (bytesUploaded, bytesTotal) {
                var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2)
                //console.log(bytesUploaded, bytesTotal, percentage + '%')
                uploadProgress(percentage)
            },
            function (error) {
                console.log('Upload Falhou, erro: ' + error)
            }
        )
    },

    captureScreen(callback) {
        this.invokeGetDisplayMedia(screen => {
            this.addStreamStopListener(screen, () => {
               // console.info('chama isso porq?');
                this.uploadToVimeo()
            })
            this.isRecordingStarted = true
            window.setTimeout(() => {
                callback(screen)
            }, 200)
        }, error => {
            this.isRecordingStarted = false
            console.error(error)
            alert('Incapaz de gravar sua tela, Porfavor veja o console.\n' + error)
        })
    },


    captureAudio(cb) {
        let constraints = {
            audio: {
                echoCancellation: true
            },
            video: false
        }
        navigator.mediaDevices.getUserMedia(constraints).then(cb)
    },

    getFileName(fileExtension) {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var date = d.getDate();
        return 'RecordRTC-' + year + month + date + '-' + '.' + fileExtension;
    },


    invokeGetDisplayMedia(success, error) {
        var displaymediastreamconstraints = {
            video: {
                displaySurface: 'monitor', // monitor, window, application, browser
                logicalSurface: true,
                cursor: 'always' // never, always, motion
            }
        };
        // above constraints are NOT supported YET
        // that's why overridnig them
        displaymediastreamconstraints = {
            video: true
        };
        if(navigator.mediaDevices.getDisplayMedia) {
            navigator.mediaDevices.getDisplayMedia(displaymediastreamconstraints).then(success).catch(error);
        }
        else {
            navigator.getDisplayMedia(displaymediastreamconstraints).then(success).catch(error);
        }
    },



    addStreamStopListener(stream, callback) {
        stream.addEventListener('ended', function() {
            callback();
            callback = function() {};
        }, false);
        stream.addEventListener('inactive', function() {
            callback();
            callback = function() {};
        }, false);
        stream.getTracks().forEach(function(track) {
            track.addEventListener('ended', function() {
                callback();
                callback = function() {};
            }, false);
            track.addEventListener('inactive', function() {
                callback();
                callback = function() {};
            }, false);
        });
    }









}